module.exports = __webpack_public_path__ + "img/Inform-management.2e229d1f.png";